import React, { useEffect, useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/Home.css';
import { useLocation, useNavigate } from "react-router-dom";
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import iconUrl from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';
import '@fortawesome/free-brands-svg-icons'
import 'react-icons/fa'
import '../styles/CallOut.css';
import { FaAmbulance } from "react-icons/fa";
import {GrShieldSecurity} from 'react-icons/gr';
import {GiTowTruck} from 'react-icons/gi';
import axios from 'axios'; 
import { Modal, ModalTitle } from "react-bootstrap";
import { FaPhone } from "react-icons/fa";



const DefaultIcon = L.icon({
  iconUrl,
  shadowUrl: iconShadow,
});
L.Marker.prototype.options.icon = DefaultIcon;

const CallOut = () => {

  const navigate = useNavigate();
  const [longitude, setLongitude] = useState(36.76820756026386);
  const [latitude, setLatitude] = useState(-1.2930847425021683);
  const [modalMessage,setModalMessage] = useState(false);
  const [messageType,setMessageType] = useState('success');
  const [messageTitle,setMessageTitle] = useState('null');
  const [messageBody,setMessageBody] = useState(null);
  const [customer,setCustomer] = useState(null);
  const [modalSubscribed,setModalSubscribed] = useState(false);
  const [selectedPackage,setSelectedPackage] = useState('single');
  const [mpesaNumber,setMpesaNumber] = useState('');
  const [loading,setLoading] = useState(false);
  const [locationLoading,setLocationLoading] = useState(true);
  const [checkoutRequestID, setCheckoutRequestID] = useState(null);
  const [paymentTimedOut, setPaymentTimedOut] = useState(false);
  

  const location = useLocation();

  const apiBaseUrl = process.env.NODE_ENV === 'development'
    ? "https://swiftresponse.online"
    : process.env.REACT_APP_API_URL;
  axios.defaults.baseURL = apiBaseUrl;
  
  // Set up axios interceptor for authentication
  axios.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem('authToken');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );


  const ShowMessage = (type,title,message) =>{
    setMessageType(type);
    setMessageTitle(title);
    setMessageBody(message);
    setModalMessage(true);
  }

  const getCustomer = async()=>{
    const userData = location.state?.customer;
    if (!userData) {
      navigate('/');
      return;
    }
    setCustomer(userData);
  }
  
  // Load customer data on component mount
  useEffect(() => {
    getCustomer();
    
    // Get user's current location
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLatitude(position.coords.latitude);
          setLongitude(position.coords.longitude);
          setLocationLoading(false);
        },
        (error) => {
          console.error('Error getting location:', error);
          setLocationLoading(false);
          // Keep using default location if geolocation fails
        }
      );
    } else {
      console.warn('Geolocation is not supported by this browser');
      setLocationLoading(false);
    }
  }, []);
  
  const shouldPromptSubscription = (err) => {
    const status = err.response?.status;
    const errorText = err.response?.data?.error || '';
    const messageText = err.response?.data?.message || '';
    const combined = `${errorText} ${messageText}`.toLowerCase();

    return status === 403 && (
      combined.includes('no active subscription') ||
      combined.includes('please subscribe')
    );
  };

  const formatSubscriptionDebug = (err) => {
    const debug = err.response?.data?.debug;
    if (!debug) {
      return '';
    }

    return `\n\n[DEBUG]\nauthCustomerId: ${debug.authCustomerId ?? 'n/a'}\nauraCustomerId: ${debug.auraCustomerId ?? 'n/a'}\nclientCustomerId: ${debug.clientCustomerId ?? 'n/a'}\nisValidFresh: ${debug.isValidFresh}\nisValidClientSnapshot: ${debug.isValidClientSnapshot}\nfreshSubscriptionCount: ${debug.freshSubscriptionCount}\nclientSubscriptionCount: ${debug.clientSubscriptionCount}`;
  };

  const MedicalRescue = async() => {
    if (!customer) {
      ShowMessage('error', 'Error', 'Customer data not found');
      return;
    }
    
    setLoading(true);
    try {
      const headers = {
        "Content-Type": "application/json",
        "Accept": "application/json",
      }
      const body = {
        "customerData": customer,
        "latitude": latitude,
        "longitude": longitude,
      }
      const url = "/medicalpanic";

      const res = await axios.post(url, body, {headers: headers});
      
      if (res.data.success) {
        ShowMessage('success', 'Medical Emergency', 'Medical assistance has been dispatched to your location');
      } else {
        console.log('res data', res.data);
        ShowMessage('error', 'Error', res.data.message || 'Failed to dispatch emergency services');
      }
    } catch (err) {
      console.error('Medical rescue error:', err);
      if (shouldPromptSubscription(err)) {
        const reason = err.response?.data?.reason || err.response?.data?.message;
        if (reason) {
          setMessageBody(`${reason}${formatSubscriptionDebug(err)}`);
          setMessageType('error');
        }
        setModalSubscribed(true);
      } else {
        ShowMessage('error', 'Error', err.response?.data?.message || err.response?.data?.error || 'Failed to dispatch emergency services');
      }
    } finally {
      setLoading(false);
    }
  }
  const SecurityPanic = async() => {
    if (!customer) {
      ShowMessage('error', 'Error', 'Customer data not found');
      return;
    }
    
    setLoading(true);
    try {
      const headers = {
        "Content-Type": "application/json",
        "Accept": "application/json",
      }
      const body = {
        "customerData": customer,
        "latitude": latitude,
        "longitude": longitude,
      }
      const url = "/securitypanic";

      const res = await axios.post(url, body, {headers: headers});
      
      if (res.data.success) {
        ShowMessage('success', 'Security Emergency', 'Security assistance has been dispatched to your location');
      } else {
        ShowMessage('error', 'Error', res.data.message || 'Failed to dispatch emergency services');
      }
    } catch (err) {
      console.error('Security panic error:', err);
      if (shouldPromptSubscription(err)) {
        const reason = err.response?.data?.reason || err.response?.data?.message;
        if (reason) {
          setMessageBody(`${reason}${formatSubscriptionDebug(err)}`);
          setMessageType('error');
        }
        setModalSubscribed(true);
      } else {
        ShowMessage('error', 'Error', err.response?.data?.message || err.response?.data?.error || 'Failed to dispatch emergency services');
      }
    } finally {
      setLoading(false);
    }
  }

  const RoadPanic = async() => {
    if (!customer) {
      ShowMessage('error', 'Error', 'Customer data not found');
      return;
    }
    
    setLoading(true);
    try {
      const headers = {
        "Content-Type": "application/json",
        "Accept": "application/json",
      }
      const body = {
        "customerData": customer,
        "latitude": latitude,
        "longitude": longitude,
      }
      const url = "/roadpanic";

      const res = await axios.post(url, body, {headers: headers});
      
      if (res.data.success) {
        ShowMessage('success', 'Road Assistance', 'Road assistance has been dispatched to your location');
      } else {
        ShowMessage('error', 'Error', res.data.message || 'Failed to dispatch emergency services');
      }
    } catch (err) {
      console.error('Road panic error:', err);
      if (shouldPromptSubscription(err)) {
        const reason = err.response?.data?.reason || err.response?.data?.message;
        if (reason) {
          setMessageBody(`${reason}${formatSubscriptionDebug(err)}`);
          setMessageType('error');
        }
        setModalSubscribed(true);
      } else {
        ShowMessage('error', 'Error', err.response?.data?.message || err.response?.data?.error || 'Failed to dispatch emergency services');
      }
    } finally {
      setLoading(false);
    }
  }

  const pollPaymentStatus = async (requestID) => {
    if (!requestID) {
      return;
    }

    const maxAttempts = 6;
    const delayMs = 5000;

    for (let attempt = 1; attempt <= maxAttempts; attempt++) {
      try {
        let res;

        try {
          res = await axios.get(`/paymentstatus/${requestID}`);
        } catch (quickCheckError) {
          const statusCode = quickCheckError?.response?.status;
          if (statusCode !== 404) {
            throw quickCheckError;
          }
          res = await axios.post('/checkpaymentstatus', { checkoutRequestID: requestID });
        }

        const status = res.data?.status;
        const activationStatus = res.data?.activationStatus;

        if (status === 'completed') {
          if (activationStatus === 'failed') {
            setMessageBody(res.data?.message || 'Payment received but subscription activation failed. Contact support.');
            setMessageType('error');
            setPaymentTimedOut(false);
            return;
          }

          setMessageBody('✓ Payment verified! Your subscription is now active.');
          setMessageType('success');
          setPaymentTimedOut(false);
          setTimeout(() => {
            window.location.reload();
          }, 2000);
          return;
        }

        if (status === 'failed') {
          setMessageBody(res.data?.message || '✗ Payment failed. Please try again.');
          setMessageType('error');
          setPaymentTimedOut(false);
          return;
        }

        setMessageBody('⏳ Payment verification in progress. Please wait...');
        setMessageType('success');
      } catch (err) {
        if (attempt === maxAttempts) {
          setMessageBody('⏱️ Payment verification is taking longer than expected. You can check the status manually below or check your M-Pesa messages.');
          setMessageType('success');
          setPaymentTimedOut(true);
        }
      }

      await new Promise(resolve => setTimeout(resolve, delayMs));
    }
  };

  const manualCheckPaymentStatus = async () => {
    if (!checkoutRequestID) {
      ShowMessage('error', 'Error', 'No payment request found. Please try again.');
      return;
    }

    setLoading(true);
    setMessageBody('🔍 Checking payment status with M-Pesa...');
    setMessageType('success');

    try {
      let res;

      try {
        res = await axios.get(`/paymentstatus/${checkoutRequestID}`);
      } catch (quickCheckError) {
        const statusCode = quickCheckError?.response?.status;
        if (statusCode !== 404) {
          throw quickCheckError;
        }
        res = await axios.post('/checkpaymentstatus', { checkoutRequestID });
      }

      const status = res.data?.status;

      if (status === 'pending') {
        res = await axios.post('/checkpaymentstatus', { checkoutRequestID });
      }

      const resolvedStatus = res.data?.status;

      if (resolvedStatus === 'completed') {
        if (res.data?.activationStatus === 'failed') {
          setMessageBody(res.data?.message || 'Payment received but subscription activation failed. Contact support.');
          setMessageType('error');
          setPaymentTimedOut(false);
          setLoading(false);
          return;
        }

        setMessageBody('✓ Payment verified! Your subscription is now active.');
        setMessageType('success');
        setPaymentTimedOut(false);
        setLoading(false);
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      } else if (resolvedStatus === 'failed') {
        setMessageBody(res.data?.message || '✗ Payment was declined. Please try again.');
        setMessageType('error');
        setPaymentTimedOut(false);
        setLoading(false);
      } else if (resolvedStatus === 'pending') {
        setMessageBody('⏳ Payment is still pending. Please wait a bit longer and check your M-Pesa for the prompt.');
        setMessageType('success');
        setLoading(false);
      }
    } catch (err) {
      const errorMsg = err.response?.data?.message || err.message || 'Failed to check payment status';
      setMessageBody(errorMsg);
      setMessageType('error');
      setLoading(false);
    }
  };

  const initiatePayment = async() => {
    setLoading(true);
    setMessageBody('');
    
    if (!mpesaNumber || mpesaNumber.trim().length < 9) {
      setMessageBody('Kindly Provide MPESA Number to Subscribe');
      setMessageType('error');
      setLoading(false);
      return;
    }
    
    // Normalize phone number
    let normalizedPhone = mpesaNumber.trim();
    if (normalizedPhone.startsWith('0')) {
      normalizedPhone = '254' + normalizedPhone.substring(1);
    } else if (normalizedPhone.startsWith('+254')) {
      normalizedPhone = normalizedPhone.substring(1);
    } else if (!normalizedPhone.startsWith('254')) {
      normalizedPhone = '254' + normalizedPhone;
    }
    
    // Validate format
    if (!/^254[17]\d{8}$/.test(normalizedPhone)) {
      setMessageBody(`${mpesaNumber} format is invalid. Use format: 0712345678 or 254712345678`);
      setMessageType('error');
      setLoading(false);
      return;
    }
    
    try {
      setMessageBody('Processing Your Payment...');
      setMessageType('success');
      
      const url = "/mpesapay";
      const header = {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }

      const isDevTestPaymentEnabled =
        process.env.NODE_ENV === 'development' &&
        process.env.REACT_APP_DEV_TEST_PAYMENT === 'true';

      const amount = isDevTestPaymentEnabled
        ? 1
        : (selectedPackage === 'single' ? 3000 : 13500);

      const customerId = customer?.customer?.id;
      if (!customerId) {
        setMessageBody('Unable to process payment: missing customer ID. Please login again.');
        setMessageType('error');
        setLoading(false);
        return;
      }

      const body = {
        'amount': amount,
        'phoneNumber': normalizedPhone,
        'customerData': {
          'customer': {
            'id': customerId,
          },
        },
      }
      
      const res = await axios.post(url, body, {headers: header});
      
      // Always capture checkoutRequestID if available
      const requestID = res.data?.checkoutRequestID;
      if (requestID) {
        setCheckoutRequestID(requestID);
      }
      
      if (res.data.success) {
        if (res.data?.activationStatus === 'failed') {
          setMessageBody(res.data?.message || 'Payment received but subscription activation failed. Contact support.');
          setMessageType('error');
          setLoading(false);
          return;
        }

        setMessageBody('✓ Payment successful! Your subscription is now active.');
        setMessageType('success');
        setLoading(false);
        setCheckoutRequestID(null);
        setPaymentTimedOut(false);
        // Refresh customer data
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      } else if (res.data?.status === 'pending') {
        // Payment still pending - verify in background
        setMessageBody(res.data.message || '⏳ Payment verification in progress. Check your M-Pesa messages and wait a moment...');
        setMessageType('success');
        setLoading(false);
        await pollPaymentStatus(requestID);
      } else if (res.data?.status === 'failed') {
        setMessageBody(res.data.message || 'Payment was cancelled or failed. Please try again.');
        setMessageType('error');
        setLoading(false);
      } else {
        setMessageBody(res.data.error || res.data.message || 'Payment failed. Please try again.');
        setMessageType('error');
        setLoading(false);
      }
    } catch (err) {
      if (process.env.NODE_ENV === 'development') {
        console.error('Payment error:', err);
      }
      
      // Always capture checkoutRequestID from error response
      const requestID = err.response?.data?.checkoutRequestID;
      if (requestID) {
        setCheckoutRequestID(requestID);
      }
      
      if (err.response?.status === 413) {
        setMessageBody('Payment request was too large. Please retry; if this persists, refresh and login again.');
        setMessageType('error');
      } else {
        const errorMessage = err.response?.data?.message || err.response?.data?.error || err.message || 'Payment failed. Please try again.';
        setMessageBody(errorMessage);
        setMessageType('error');
      }
      setLoading(false);
    }
  }

  return (
    <div style={{height:'100vh', width:'100vw'}}>
       
      <MapContainer key={`${latitude}-${longitude}`} style={{width:'100vw', height:'70vh'}} center={[latitude, longitude]} zoom={13} scrollWheelZoom={false}>
        <TileLayer
          attribution='&copy; OpenStreetMap contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <Marker position={[latitude, longitude]}>
          <Popup>
            Your Location 
          </Popup>
        </Marker>
      </MapContainer>
      
      <div style={{width:'100vw', height:'20vh', justifyContent:'center', alignItems:'center', display:'flex'}} className="options d-flex p-3 my-3 justify-content-between">
        <div className="btn text-center text-warning" onClick={MedicalRescue} disabled={loading}>
          <div className="shadow span rounded-circle">
            <FaAmbulance/>
          </div>
          <p><small>{loading ? 'Dispatching...' : 'Medical'}</small></p>
        </div>
        <div className="btn text-center text-danger" onClick={SecurityPanic} disabled={loading}>
          <div className="shadow span rounded-circle">
            <GrShieldSecurity/>
          </div>
          <p><small>{loading ? 'Dispatching...' : 'Security'}</small></p>
        </div>
        <div className="btn text-center text-primary" onClick={RoadPanic} disabled={loading}>
          <div className="shadow span rounded-circle">
            <GiTowTruck/>
          </div>
          <p><small>{loading ? 'Dispatching...' : 'Road Rescue'}</small></p>
        </div>
      </div>

      {/* Subscription Modal */}
      <Modal show={modalSubscribed}>
        <Modal.Header closeButton onHide={() => { setModalSubscribed(false); setMessageBody(''); setCheckoutRequestID(null); setPaymentTimedOut(false); }}>
          <Modal.Title className="text-start">You are not Subscribed</Modal.Title>
        </Modal.Header>
        <Modal.Body className="modalBody">
          <div className="container-fluild">
            <p className="text-danger text-start">Kindly Select Subscription Package:</p>
          </div>
          <div className="form-body">
            <div className="input-group">
              <div className="input-group-prepend">
                <span className="input-group-text">
                  Package
                </span>
              </div>
              <select className="form-select" onChange={(e)=>{
                setSelectedPackage(e.target.value);
              }}>
                <option value='single'>Single Package @ 3,000 Ksh/yr</option>
                <option value='family'>Family Package @ 15,500 Ksh/yr</option>
              </select>
            </div>
            <div className="input-group my-3">
              <div className="input-group-prepend">
                <span className="input-group-text">
                  MPESA
                </span>
              </div>
              <input className="form-control" type="tel" placeholder="+254712345678" onChange={(e)=>{
                setMpesaNumber(e.target.value);
              }}/>
            </div>
            {messageType === 'success' ? 
              <div className="form-group">
                <p className="text-success">{messageBody}</p>
              </div> :
              <div className="form-group">
                <p className="text-danger">{messageBody}</p>
              </div>
            }
            {checkoutRequestID && (
              <div className="mt-3">
                <button 
                  className="btn btn-warning btn-sm w-100" 
                  onClick={manualCheckPaymentStatus}
                  disabled={loading}
                >
                  {loading ? 'Checking...' : '🔄 Check Payment Status'}
                </button>
                <small className="text-muted d-block mt-2">Click to verify if your payment was successful</small>
              </div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button 
            className="btn btn-secondary btn-sm" 
            onClick={() => { setModalSubscribed(false); setMessageBody(''); setCheckoutRequestID(null); setPaymentTimedOut(false); }}
          >
            Close
          </button>
          <button 
            className="btn btn-success btn-md" 
            onClick={initiatePayment}
            disabled={loading}
          >
            {loading ? 'Processing...' : 'Pay Now'}
          </button>
        </Modal.Footer>
      </Modal>

      {/* Message Modal */}
      <Modal show={modalMessage}>
        {messageType === 'success' ? 
          <Modal.Header className="bg-success" closeButton>
            <Modal.Title>{messageTitle}</Modal.Title>
          </Modal.Header> :
          <Modal.Header className="bg-danger" closeButton>
            <Modal.Title>{messageTitle}</Modal.Title>
          </Modal.Header>
        }
        <Modal.Body>
          <p className="text-info">{messageBody}</p>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-danger btn-sm mx-auto d-block" onClick={()=>{
            setModalMessage(false);
          }}>Close</button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default CallOut;
